import { FormattedDate, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import defaultShield from 'assets/club/shield_none.webp';
import { Vertical } from 'atoms/layout/flex';
import { LabelL, LabelS } from 'atoms/typography';
import { Row } from 'components/seo/ui';

const Logo = styled.img`
  width: 100%;
`;

export type Props<T extends string> = {
  stats: T[];
  transfer: {
    id: string;
    team: {
      officialName: string;
      pictureUrl?: string | null;
      to?: string;
    };
    startDate: Date;
    endDate: Date | null;
    stats: Record<T, number>;
  };
};

export const Transfer = <T extends string>({ transfer, stats }: Props<T>) => {
  return (
    <Row
      style={{
        gridTemplateColumns: `var(--triple-unit) 1fr repeat(${stats.length}, var(--quadruple-unit))`,
      }}
    >
      <Logo src={transfer.team.pictureUrl || defaultShield} alt="" />
      <Vertical gap={0}>
        <LabelL as="p" bold>
          {transfer.team.to ? (
            <Link to={transfer.team.to}>{transfer.team.officialName}</Link>
          ) : (
            transfer.team.officialName
          )}
        </LabelL>
        <LabelS as="p" color="var(--c-nd-600)">
          <FormattedDate value={transfer.startDate} year="numeric" />
          {' - '}
          {transfer.endDate ? (
            <FormattedDate value={transfer.endDate} year="numeric" />
          ) : (
            <FormattedMessage
              id="Seo.Transfers.Transfer.now"
              defaultMessage="Now"
            />
          )}
        </LabelS>
      </Vertical>
      {stats.map(stat => (
        <LabelL as="p" key={stat}>
          {transfer.stats[stat]}
        </LabelL>
      ))}
    </Row>
  );
};
